<div class="santa-flex santa-justify-between santa-items-center">
  <santa-button type="additional" (click)="toPrevious()">{{ translations.navigation.prev | translate }}</santa-button>
  <santa-button (click)="toNext()">{{ translations.navigation.next | translate }}</santa-button>
</div>
